module.exports = __webpack_public_path__ + "static/media/footer-logo.0c74da81.svg";